import { configureStore } from "@reduxjs/toolkit";

//reducer
import modalReducer from "./reducer/modal.reducer";
import profileReducer from "./reducer/profile.reducer";
import commonReducer from "./reducer/common.reducer";
import productReducer from "./reducer/product.reducer";
import orderReducer from "./reducer/order.reducer";
import consignReducer from "./reducer/consign.reducer";

const reducer = {
  modal: modalReducer,
  profile: profileReducer,
  common: commonReducer,
  product: productReducer,
  order: orderReducer,
  consign: consignReducer,
};

const store = configureStore({
  reducer: reducer,
  devTools: process.env.REACT_APP_DEV_TOOL,
});

export default store;
